import {
    createLoadingSpinner,
    LOADING_SPINNER_COLOR_PRIMARY,
    LOADING_SPINNER_SIZE_MEDIUM,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { startAppListening } from '../app/listener';
import { selectIsLoading } from '../features/app/selectors';

/**
 * Mount loading spinner
 */
export const mountLoadingSpinner = (containerId: string): LoadingSpinner | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const loadingSpinner = createLoadingSpinner(container, {
        optColor: LOADING_SPINNER_COLOR_PRIMARY,
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: {},
    });

    listenForUpdates(loadingSpinner);

    return loadingSpinner;
};

const listenForUpdates = (loadingSpinner: LoadingSpinner) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectIsLoading(currentState) !== selectIsLoading(previousState)
        ,
        effect: (_action, listenerApi) => {
            const isLoading = selectIsLoading(listenerApi.getState());
            loadingSpinner?.toggle(isLoading);
        },
    });
};
